import * as THREE from 'three';

// import concreteImgOld from '../../assets/textures/concrete_3_old.jpg';
import concreteImgSpit from '../../assets/textures/Concrete_1.jpg';
// import concreteImgRedHead from '../../assets/textures/Concrete_3.jpg';
// import concreteImgRamset from '../../assets/textures/Concrete_2.jpg';
import masonryRedImg from '../../assets/textures/masonry_1.jpg';
import masonryRed2Img from '../../assets/textures/masonry_5.jpg';
import masonryGrayImg from '../../assets/textures/masonry_3.jpg';
import masonryWhiteImg from '../../assets/textures/masonry_4.jpg';
// import { BRAND } from '@config';
// import { brandList } from './../../app.values';

const textureConcrete = new THREE.TextureLoader().load(
	// BRAND === brandList.Spit ? concreteImgSpit : 
	// BRAND === brandList.Redhead ? concreteImgRedHead :
	// BRAND === brandList.Ramset ? concreteImgRamset : concreteImgOld);
	concreteImgSpit);
textureConcrete.wrapS = textureConcrete.wrapT = THREE.RepeatWrapping;

const textureMasonryRed = new THREE.TextureLoader().load(masonryRedImg);
textureMasonryRed.wrapS = THREE.RepeatWrapping;
textureMasonryRed.wrapT = THREE.RepeatWrapping;
textureMasonryRed.repeat.set(0.75, 0.75);
textureMasonryRed.rotation = -Math.PI / 2;

const textureMasonryRed_2 = new THREE.TextureLoader().load(masonryRed2Img);
textureMasonryRed_2.wrapS = THREE.RepeatWrapping;
textureMasonryRed_2.wrapT = THREE.RepeatWrapping;
textureMasonryRed_2.repeat.set(0.75, 0.75);
textureMasonryRed_2.rotation = -Math.PI / 2;

const textureMasonryWhite = new THREE.TextureLoader().load(masonryWhiteImg);
textureMasonryWhite.wrapS = THREE.RepeatWrapping;
textureMasonryWhite.wrapT = THREE.RepeatWrapping;
textureMasonryWhite.repeat.set(0.75, 0.75);
textureMasonryWhite.rotation = -Math.PI / 2;

const textureMasonryGray = new THREE.TextureLoader().load(masonryGrayImg);
textureMasonryGray.wrapS = THREE.RepeatWrapping;
textureMasonryGray.wrapT = THREE.RepeatWrapping;
textureMasonryGray.repeat.set(0.75, 0.75);
textureMasonryGray.rotation = -Math.PI / 2;

export const concreteMaterial = new THREE.MeshLambertMaterial({
	map: textureConcrete
});

export const masonryMaterialWhite = new THREE.MeshLambertMaterial({
    map: textureMasonryWhite
});

export const masonryMaterialGray = new THREE.MeshLambertMaterial({
    map: textureMasonryGray
});

export const masonryMaterialRed = new THREE.MeshLambertMaterial({
    map: textureMasonryRed
});

export const masonryMaterialRed_2 = new THREE.MeshLambertMaterial({
    map: textureMasonryRed_2
});

// VladP: Keep the masonry materials as const, otherwise the depthTest = false of the load arrows will have no effect
export function GetMasonryMaterial(color) {
	switch (color) {
		case "white": {
			return masonryMaterialWhite;
		}
		case "gray": {
			return masonryMaterialGray;
		}
		case "concrete": {
			return concreteMaterial;
		}
		case "red_2": {
			return masonryMaterialRed_2;
		}
		case "red":
		default: {
			return masonryMaterialRed;
		}
	}
}



// WEBPACK FOOTER //
// ./src/object-view/materials/ground.js